<template>
  <div class="typography-what-not-content" id="identidade-visual-tipografia-aplicacoes" data-search-anchor>
    <div class="title-typography-what-not-wrapper">
      <h1 class="typography-what-not-span">{{ typographyWhatNotToDoTitleSpan }}</h1>
      <h1 class="typography-what-not-title">{{ typographyWhatNotToDoTitle }}</h1>
    </div>
    <div class="description-typography-what-not-wrapper">
      <div class="typography-what-not-icon">
        <IconCancel />
        <p class="typography-what-not-description">{{ typographyWhatNotToDoDescription1 }}</p>
      </div>

      <div class="typography-what-not-fica-a-dica">
        <p class="fica-a-dica">
          {{ typographyWhatNotToDoDescription2 }}
        </p>
        <p class="typography-what-not-description3">
          {{ typographyWhatNotToDoDescription3 }}
        </p>
      </div>
    </div>
    <div
      class="typography-what-not-card-item"
      :style="{ backgroundImage: `url(${typographyWhatNotToDoImageSrc})` }"
    ></div>

    <div class="title-typography-what-not-wrapper">
      <h1 class="typography-what-not-span">{{ typographyWhatNotToDoAplicacaoTitleSpan }}</h1>
      <h1 class="typography-what-not-title">{{ typographyWhatNotToDoAplicacaoTitle }}</h1>
    </div>
    <div
      class="typography-what-not-card-item2"
      :style="{ backgroundImage: `url(${typographyWhatNotToDoImageSrc2})` }"
    ></div>
  </div>
</template>

<script lang="ts">
import IconCancel from '@/assets/icons/IconCancel.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import TypographyPageMixin from '@/mixins/typography-page-mixin'
import { TypographyPageStore } from '@/store/visual-identity-page/typography-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({ components: { IconCancel } })
export default class TypographyWhatNotToDoSection extends Mixins(TypographyPageMixin) {
  typographyPageStore: PageStoreContract = getModule(TypographyPageStore, this.$store)

  get typographyWhatNotToDoTitleSpan(): string {
    return this.getElementTitle(9, 0)
  }

  get typographyWhatNotToDoTitle(): string {
    return this.getElementText(9, 0)
  }

  get typographyWhatNotToDoDescription1(): string {
    return this.getElementText(9, 1)
  }

  get typographyWhatNotToDoDescription2(): string {
    return this.getElementText(9, 2)
  }

  get typographyWhatNotToDoDescription3(): string {
    return this.getElementText(9, 3)
  }

  get typographyWhatNotToDoImageSrc(): string {
    return this.getElementMedia(9, 3)
  }

  get typographyWhatNotToDoImageSrc2(): string {
    return this.getElementMedia(9, 4)
  }

  get typographyWhatNotToDoAplicacaoTitleSpan(): string {
    return this.getElementTitle(9, 4)
  }

  get typographyWhatNotToDoAplicacaoTitle(): string {
    return this.getElementText(9, 4)
  }

  async getTypographyPage(): Promise<void> {
    await this.typographyPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.typographyPageStore.isLoading) {
      await this.getTypographyPage()
    }
  }
}
</script>

<style lang="scss">
.typography-what-not-content {
  display: grid;
  max-width: 1032px;
  width: 100%;
}

.title-typography-what-not-wrapper {
  display: flex;
  align-items: center;
  height: 6vh;
  padding-top: 6.25rem;
  padding-bottom: 1rem;
}

.typography-what-not-span {  
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  margin-right: 5px;
  color: #b3b3b3;
}

.typography-what-not-title {  
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  color: #000000;
}

.typography-what-not-icon {
  display: flex;
  align-items: center;
}

.description-typography-what-not-wrapper {  
  position: relative;  
  align-items: flex-start;

  display: grid;
  grid-template-columns: 51.2% 48.8%; 
}

.typography-what-not-description {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
  padding-left: 7px;
  
  width: 378px;
  white-space: pre-line;
}

.typography-what-not-fica-a-dica{
  margin-top: 1rem;
}

.fica-a-dica,
.typography-what-not-description3 {
  font-size: 16px;  
  font-weight: 600;
  line-height: 20px;
  text-align: left;

  margin-top: 0;
  width: 430px;
}
.typography-what-not-card-item {
  position: relative; 

  max-width: 1032px;
  width: 100%;
  height: 705px;

  border-radius: 8px;

  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.typography-what-not-card-item2 {
  position: relative; 

  max-width: 1032px;
  width: 100%;
  height: 535px;

  border-radius: 8px; 
  margin-bottom: 2rem;

  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
</style>
